import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { queryClient } from 'providers';

const { removeCouponBulk } = TransectionApiServices();

type UpdateStatusVariables = {
  payload: any;
  origin: string;
};

export const useUpdateStatus = () => {
  const { message } = App.useApp();

  return useMutation(
    ({ payload, origin }: UpdateStatusVariables) => {
      return removeCouponBulk(payload, origin);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        queryClient.invalidateQueries({
          queryKey: eventsQueryKeys.all,
        });

        if (data.ResponseStatus === 1) {
          message.success(data.ResponseMessage);
        } else {
          message.error(data.ResponseMessage);
        }
      },
    }
  );
};
